import { render, staticRenderFns } from "./TabularRow.vue?vue&type=template&id=56ff964a&"
import script from "./TabularRow.vue?vue&type=script&lang=js&"
export * from "./TabularRow.vue?vue&type=script&lang=js&"
import style0 from "./TabularRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports